/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import VueCookies from 'vue-cookies';
const actions = {
    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
        commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width);
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
        commit('UPDATE_STARRED_PAGE', payload);
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list);
    },
    arrangeStarredPagesMore({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list);
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
        commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
        commit('UPDATE_THEME', val);
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
        commit('UPDATE_USER_INFO', payload);
    },

    async loginUser({ commit }, payload) {
        commit('setUID', payload.data.UID);
        commit('setTOKEN', payload.token);

        commit('setUSERNAME', payload.data.USERNAME);
        commit('setCDLEVEL', payload.data.CD_LEVEL);
        commit('setTABSUM', payload.data.TAB_SUM);
        commit('setMemberEmail', payload.data.MEMBER_EMAIL);

        await VueCookies.remove('uid');
        await VueCookies.remove('username');
        await VueCookies.remove('cd_level');
        await VueCookies.remove('token');
        await VueCookies.remove('tab_sum');

        await VueCookies.remove('tab_sum_01');
        await VueCookies.remove('tab_sum_03');
        await VueCookies.remove('memberEmail');

        await VueCookies.set('uid', payload.data.UID, 0);
        await VueCookies.set('username', payload.data.USERNAME, 0);
        await VueCookies.set('cd_level', payload.data.CD_LEVEL, 0);
        await VueCookies.set('tab_sum', payload.data.TAB_SUM, 0);

        await VueCookies.set('tab_sum_01', payload.data.TAB_SUM_01, 0);
        await VueCookies.set('tab_sum_03', payload.data.TAB_SUM_03, 0);
        await VueCookies.set('memberEmail', payload.data.MEMBER_EMAIL, 0);
        await VueCookies.set('token', payload.token, 0);
    },

    async logoutUser({ commit }) {
        commit('setUID', '');
        commit('setTOKEN', '');
        commit('setUSERNAME', '');
        commit('setCDLEVEL', '');
        commit('setTABSUM', '');
        commit('setMemberEmail', '');

        VueCookies.remove('uid');
        VueCookies.remove('username');
        VueCookies.remove('cd_level');
        VueCookies.remove('token');

        VueCookies.remove('tab_sum');

        VueCookies.remove('tab_sum_01');
        VueCookies.remove('tab_sum_03');
        VueCookies.remove('memberEmail');
    },
};

export default actions;
